var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbOperational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14a7 7 0 10-7-7 7 7 0 007 7zm4.15-9.27a.5.5 0 00-.71-.73L6.13 8.33 3.85 6.06a.5.5 0 00-.7 0 .5.5 0 000 .71L5.77 9.4a.51.51 0 00.71 0z",
    fill: "#26b382",
    fillRule: "evenodd",
    "data-name": "Layer 1"
  }))));
}

export default SvgCustomDnbOperational;